import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../../core/utils/is-slot.js';
import { ColorRule, isValidColorRule } from '../../../core/slots/ColorRule.js';
import type { ChartDatapoint } from '../../../core/types/chart-data.js';
import type {
  FlameChartTooltipSlot,
  FlameGraphTooltipSlot,
} from '../slots/Tooltip.js';
import type { CustomTooltipTemplate, Slots } from '../types/flame-internal.js';

type TooltipSlot = typeof FlameChartTooltipSlot | typeof FlameGraphTooltipSlot;

export const makeIterateSlots =
  (TooltipSlot: TooltipSlot) =>
  <TData extends ChartDatapoint = ChartDatapoint>(
    children: ReactNode,
  ): Slots<TData> => {
    const slots: Slots<TData> = {
      customTooltipTemplate: undefined,
      colorRules: [],
    };

    Children.forEach(children, (child) => {
      if (isSlot(child, TooltipSlot)) {
        slots.customTooltipTemplate = child.props
          .children as CustomTooltipTemplate<TData>;
      } else if (isSlot(child, ColorRule) && isValidColorRule(child.props)) {
        slots.colorRules.push(child);
      }
    });

    return slots;
  };
